import React from 'react';
import './ui.css';

export function YFormField({
  label,
  htmlFor,
  help,
  error,
  required = false,
  children,
  className = '',
  labelClassName = 'y-label',
}) {
  return (
    <div className={`y-field ${className}`.trim()} data-yona="field">
      {label && (
        <label className={labelClassName} htmlFor={htmlFor}>
          {label}
          {required ? <span className="y-required" aria-hidden="true"> *</span> : null}
        </label>
      )}
      <div className="y-control">
        {children}
      </div>
      {help && !error && <div className="y-help" role="note">{help}</div>}
      {error && <div className="y-error" role="alert">{error}</div>}
    </div>
  );
}
